import { FC, useRef, useEffect, useCallback } from 'react'
import s from './Modal.module.css'
import FocusTrap from '@lib/focus-trap'
import { Cross } from '@components/icons'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import cn from 'clsx'

interface ModalProps {
  containerClassName?: string
  childrenClassName?: string
  children?: any
  onClose: () => void
  onEnter?: () => void | null
  header?: string
}

const Modal: FC<ModalProps> = ({
  children,
  onClose,
  containerClassName,
  childrenClassName,
  header,
}) => {
  const ref = useRef() as React.MutableRefObject<HTMLDivElement>

  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        return onClose()
      }
    },
    [onClose]
  )

  useEffect(() => {
    const modal = ref.current

    if (modal) {
      /* disableBodyScroll(modal, { reserveScrollBarGap: true }) */
      window.addEventListener('keydown', handleKey)
    }
    return () => {
      clearAllBodyScrollLocks()
      window.removeEventListener('keydown', handleKey)
    }
  }, [handleKey])

  return (
    <div className={s.root}>
      <div
        className={containerClassName ? containerClassName : s.modal}
        role="dialog"
        ref={ref}
      >
        <div className={cn({ [s.header]: header })}>
          {header && <h2>{header}</h2>}
          <button
            onClick={() => onClose()}
            aria-label="Close panel"
            className={header ? s.closeInHeader : s.close}
          >
            <Cross className="h-6 w-6" />
          </button>
        </div>
        <FocusTrap focusFirst className={childrenClassName}>
          {children}
        </FocusTrap>
      </div>
    </div>
  )
}

export default Modal
